// TRB.jsx

import React, { useState, useEffect } from "react";
import {
  User,
  Mail,
  Phone,
  MapPin,
  Calendar,
  Clock,
  Bike,
  Store,
  Eye,
  X,
} from "lucide-react";

import axios from "axios";
import "../css/TRB.css";

const TRB = () => {
  const [trbBookings, setTrbBookings] = useState([]);
  const [selectedTrbBooking, setSelectedTrbBooking] =
    useState(null);

  useEffect(() => {
    fetchBookings();
  }, []);

  const fetchBookings = async () => {
    try {
      const res = await axios.get(
        "/api/testride"
      );

      setTrbBookings(res.data.data || []);
    } catch (error) {
      console.error("Error fetching bookings:", error);
    }
  };

  return (
    <div className="trb-page">

      {/* HEADER */}
      <div className="trb-header">
        <div>
          <h1>Test Ride Bookings</h1>
          <p>Manage all test ride requests</p>
        </div>

        <div className="trb-count-card">
          Total Bookings: {trbBookings.length}
        </div>
      </div>

      {/* TABLE */}
      <div className="trb-table-wrapper">
        <table className="trb-table">

          <thead>
            <tr>
              <th>ID</th>
              <th>Customer</th>
              <th>Model</th>
              <th>Ride Type</th>
              <th>City</th>
              <th>Date</th>
              <th>Time</th>
              <th>Dealer</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {trbBookings.map((booking) => (
              <tr key={booking.id}>

                <td>
                  <span className="trb-booking-id">
                    #{booking.id}
                  </span>
                </td>

                <td>
                  <div className="trb-customer-name">
                    {booking.t1}
                  </div>

                  <div className="trb-customer-phone">
                    {booking.t4}
                  </div>
                </td>

                <td>
                  <div className="trb-model-name">
                    {booking.t8}
                  </div>
                </td>

                <td>{booking.t7}</td>

                <td>{booking.t6}</td>

                <td>{booking.s14}</td>

                <td>{booking.s15 || "-"}</td>

                <td>{booking.t9 || "-"}</td>

                <td>
                  <button
                    className="trb-view-btn"
                    onClick={() =>
                      setSelectedTrbBooking(booking)
                    }
                  >
                    <Eye size={16} />
                    View
                  </button>
                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* MODAL */}
      {selectedTrbBooking && (
        <div className="trb-modal-overlay">

          <div className="trb-modal">

            {/* HEADER */}
            <div className="trb-modal-header">

              <div>
                <h2>
                  Booking #{selectedTrbBooking.id}
                </h2>

                <p>
                  Created on{" "}
                  {new Date(
                    selectedTrbBooking.created
                  ).toLocaleDateString()}
                </p>
              </div>

              <button
                className="trb-close-btn"
                onClick={() =>
                  setSelectedTrbBooking(null)
                }
              >
                <X size={26} />
              </button>

            </div>

            {/* BODY */}
            <div className="trb-modal-body">

              {/* CUSTOMER */}
              <div className="trb-section">

                <h3>Customer Details</h3>

                <div className="trb-details-grid">

                  <div className="trb-detail-card">
                    <User size={18} />

                    <div>
                      <span>Full Name</span>
                      <p>{selectedTrbBooking.t1}</p>
                    </div>
                  </div>

                  <div className="trb-detail-card">
                    <Phone size={18} />

                    <div>
                      <span>Phone</span>
                      <p>{selectedTrbBooking.t4}</p>
                    </div>
                  </div>

                  <div className="trb-detail-card">
                    <Mail size={18} />

                    <div>
                      <span>Email</span>
                      <p>{selectedTrbBooking.t3}</p>
                    </div>
                  </div>

                  <div className="trb-detail-card">
                    <MapPin size={18} />

                    <div>
                      <span>City</span>
                      <p>{selectedTrbBooking.t6}</p>
                    </div>
                  </div>

                  <div className="trb-detail-card">
  <MapPin size={18} />

  <div>
    <span>Address</span>

    <p>
      {selectedTrbBooking.s16 || "-"}
    </p>
  </div>
</div>

                </div>
              </div>

              {/* BOOKING */}
              <div className="trb-section">

                <h3>Booking Details</h3>

                <div className="trb-details-grid">

                  <div className="trb-detail-card">
                    <Bike size={18} />

                    <div>
                      <span>Model</span>
                      <p>{selectedTrbBooking.t8}</p>
                    </div>
                  </div>

                  <div className="trb-detail-card">
                    <Bike size={18} />

                    <div>
                      <span>Ride Type</span>
                      <p>{selectedTrbBooking.t7}</p>
                    </div>
                  </div>

                  <div className="trb-detail-card">
                    <Calendar size={18} />

                    <div>
                      <span>Date</span>
                      <p>{selectedTrbBooking.s14}</p>
                    </div>
                  </div>

                  <div className="trb-detail-card">
                    <Clock size={18} />

                    <div>
                      <span>Time Slot</span>
                      <p>
                        {selectedTrbBooking.s15 || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="trb-detail-card">
                    <Store size={18} />

                    <div>
                      <span>Dealer Name</span>
                      <p>
                        {selectedTrbBooking.t9 || "-"}
                      </p>
                    </div>
                  </div>

                  <div className="trb-detail-card">
                    <Calendar size={18} />

                    <div>
                      <span>Submitted At</span>
                      <p>
                        {new Date(
                          selectedTrbBooking.created
                        ).toLocaleString()}
                      </p>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TRB;